import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  title: {
    fontSize: 20,
    fontWeight: '800',
    marginBottom: 24,
  },
})
